import { ManageCamerasComponent } from './manage-cameras/manage-cameras.component';
import { MicroframeComponent } from './microframe/microframe.component';
import { ViewCamerasComponent } from './view-cameras/view-cameras.component';
import { TracktennisComponent } from './tracktennis/tracktennis.component';
import { Routes, RouterModule } from '@angular/router';
import { VideoStreamProviderListComponent } from './video-stream-provider-list.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

// const routes: Routes = [
//     {
//         path: '',
//         component: VideoStreamProviderListComponent,
//     },
//     {
//         path: 'tracktennis',
//         component: TracktennisComponent
//     }
// ];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        // RouterModule.forChild(routes),
        TranslateModule
    ],
    declarations: [
        VideoStreamProviderListComponent,
        TracktennisComponent,
        ViewCamerasComponent,
        MicroframeComponent,
        ManageCamerasComponent
    ]
})
export class VideoStreamProviderListModule { }
